// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  uploadId: __t.u64().primaryKey().name("upload_id"),
  uploader: __t.identity(),
  originalFilename: __t.string().name("original_filename"),
  rawUri: __t.string().name("raw_uri"),
  useClass: __t.string().name("use_class"),
  worldId: __t.u64().name("world_id"),
  status: __t.string(),
  rejectReason: __t.string().name("reject_reason"),
  assetId: __t.u64().name("asset_id"),
  createdAt: __t.timestamp().name("created_at"),
});
